import { brandLogo } from '@/assets/images';

export default function Footer() {
  return (
    <footer className="bg-ink-900 text-cream-50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-1">
            <img
              src={brandLogo}
              alt="SANO Moda"
              title="SANO Moda · Llíria, Valencia"
              className="h-8 w-auto mb-5 brightness-0 invert"
            />
            <p className="font-display italic text-cream-50/70 text-lg">
              Más de 38 años a tu lado
            </p>
          </div>

          <div>
            <p className="text-[10px] tracking-widest text-cream-50/50 mb-5">NAVEGACIÓN</p>
            <ul className="space-y-3">
              {['Inicio', 'Mujer', 'Hombre', 'Colecciones', 'Sobre Sano', 'Contacto'].map((l) => (
                <li key={l}>
                  <a href={`#${l.toLowerCase().replace(/\s/g, '')}`} className="text-sm text-cream-50/80 hover:text-cream-50 transition-colors cursor-pointer">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-[10px] tracking-widest text-cream-50/50 mb-5">CONTACTO</p>
            <ul className="space-y-3 text-sm text-cream-50/80">
              <li>Calle San Vicente Ferrer, 34</li>
              <li>46160 Llíria, Valencia</li>
              <li><a href="tel:+34962782616" className="hover:text-cream-50 cursor-pointer">962 782 616</a></li>
              <li><a href="mailto:sanoropa@gmail.com" className="hover:text-cream-50 cursor-pointer">sanoropa@gmail.com</a></li>
            </ul>
          </div>

          <div>
            <p className="text-[10px] tracking-widest text-cream-50/50 mb-5">SÍGUENOS</p>
            <a
              href="https://instagram.com/ropasano"
              target="_blank"
              rel="noreferrer"
              className="flex w-fit items-center gap-3 text-sm text-cream-50/80 hover:text-cream-50 transition-colors cursor-pointer mb-3"
            >
              <i className="ri-instagram-line text-lg"></i>
              @ropasano
            </a>
            <a
              href="https://www.facebook.com/share/1JXngLyhbp/?mibextid=wwXIfr"
              target="_blank"
              rel="noreferrer"
              className="flex w-fit items-center gap-3 text-sm text-cream-50/80 hover:text-cream-50 transition-colors cursor-pointer mb-3"
            >
              <i className="ri-facebook-circle-line text-lg"></i>
              Facebook
            </a>
          </div>
        </div>

        <div className="border-t border-cream-50/15 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-cream-50/50">
            © 2026 SANO Moda · Llíria, Valencia. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6 text-xs text-cream-50/60">
            <a href="#" className="hover:text-cream-50 cursor-pointer">Aviso legal</a>
            <a href="#" className="hover:text-cream-50 cursor-pointer">Política de privacidad</a>
            <a href="#" className="hover:text-cream-50 cursor-pointer">Política de cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}